import axios from "axios";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const Steps3 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [showContact, setShowContact] = useState("false");
  const [contactType, setContactType] = useState("Mobile");
  const [showOtpField, setShowOtpField] = useState(false);
  const [otpTrue, setOtpTrue] = useState(false);

  const [formData, setFormData] = useState();

  const initialErrorData = {
    mobileNumber: "",
  };

  const [errors, setErrors] = useState(initialErrorData);
  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      setFormData({ ...formData, [name]: value });
    }
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    // Create a mapping of field names to user-friendly labels
    const fieldLabels = {
      mobileNumber: "Mobile Number",
      otp: "OTP",
      email: "Email",
      contactemail: "Contact Email",
      contactmobileNumber: "Contact Mobile Number",
    };

    Object.keys(newErrors).forEach((key) => {
      const fieldValue = formData[key]?.trim();
      if (!fieldValue) {
        newErrors[key] = `Please enter ${fieldLabels[key] || key}`;
        isValid = false;
      }
      if (key === "mobileNumber") {
        if (
          fieldValue &&
          (fieldValue.length !== 10 || !/^\d{10}$/.test(fieldValue))
        ) {
          newErrors[key] = "Mobile number must be 10 digits";
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      detailsSet(formData);
      setCount(count + 1);
      completeCurrentStep(count);
    }
  };

  const handleContact = () => {
    setShowContact(!showContact);
  };

  const handleContactType = (e) => {
    setContactType(e.target.value);
  };

  const sendOtp = () => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=otp&mobile=${formData?.mobileNumber}&format=new`
      )
      .then((res) => {
        console.log(res);
        if (res?.data?.status) {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "success",
          });
          setShowOtpField(true);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
          setShowOtpField(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error",
        });
      });
  };

  const checkOtpCurrect = () => {
    if (formData?.otp != "") {
      axios
        .post(
          `https://anoopam.com/aims/api/?action=verifyotp&mobile=${formData?.mobileNumber}&otp=${formData?.otp}&format=new`
        )
        .then((res) => {
          console.log(res);
          if (res?.data?.status) {
            Swal.fire({
              text: `${res?.data?.message}`,
              icon: "success",
            });
            // Update formData with verification status
            setFormData((prev) => ({ ...prev, isVerified: true }));
          } else {
            Swal.fire({
              text: `${res?.data?.message}`,
              icon: "error",
            });
            setFormData((prev) => ({ ...prev, isVerified: false }));
          }
        })
        .catch((err) => {
          Swal.fire({
            text: `${err?.data?.message}`,
            icon: "error",
          });
        });
    } else {
      Swal.fire({
        text: `Enter Your OTP`,
        icon: "error",
      });
    }
  };
  const handleSendOtp = () => {
    const isValid = validateForm(); // Validate the form
    if (isValid) {
      sendOtp();
    }
  };

  const checkOtp = () => {
    checkOtpCurrect();
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* <div className="stepProgrees text-start mt-2">
        <p className="d-flex tittle-text mb-0">
          <b style={{ color: "#034DA2" }} className="">
            Contact
          </b>
        </p>
        <p style={{ color: "#034DA2" }} className="tittle-text mb-0">
          Contact Info
        </p>
      </div> */}
      <div className="mt-4 main p-4 border rounded-4  bg-white">
        <div className=" row col-12 ">
          <div className="col-lg-5 col-md-8">
            <label className="tittle-text" htmlFor="mobileNumber">
              Mobile Number
            </label>
            <div className="d-flex flex-column flex-md-row gap-3">
              <div>
                <input
                  type="number"
                  id="mobileNumber"
                  name="mobileNumber"
                  value={formData?.mobileNumber || ""}
                  onChange={handleInputChange}
                  placeholder="Enter Mobile Number"
                  className="form-control mt-2"
                />
                {errors?.mobileNumber && (
                  <span className="text-danger fw-medium mt-1 d-inline-block">
                    {errors?.mobileNumber}
                  </span>
                )}
              </div>
              <div className="col-4">
                <button
                  type="button"
                  className="otpButton"
                  onClick={handleSendOtp}
                  // disabled={formData?.mobileNumber?.length !== 10}
                >
                  Send OTP
                </button>
              </div>
            </div>
          </div>
        </div>
        {showOtpField && (
          <div className=" row col-12 ">
            <div className="col-lg-5 col-md-8">
              <label className="tittle-text" htmlFor="">
                Enter OTP
              </label>
              <div className="d-flex flex-column flex-md-row gap-3">
                <div>
                  <input
                    type="number"
                    name="otp"
                    value={formData?.otp || ""}
                    onChange={handleInputChange}
                    placeholder="4 Digit OTP"
                    className="form-control mt-2 "
                  />
                </div>
                <div className="col-4">
                  <button
                    type="button"
                    className="otpButton text-nowrap px-3"
                    onClick={checkOtp}
                    // disabled={formData?.mobileNumber?.length !== 10}
                  >
                    Verify OTP
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row col-12 mt-3 ">
          <div className="col-md-4 ">
            <label className="tittle-text" htmlFor="email">
              Email
            </label>
            <div className="d-flex gap-5 ">
              <input
                type="text"
                name="email"
                value={formData?.email || ""}
                onChange={handleInputChange}
                placeholder="Enter Your Email"
                className="form-control mt-2 "
              />
            </div>
          </div>

          {!showContact && (
            // <div className="row  mt-2  align-items-center">
            //   <div className="col-md-2">
            //     <label
            //       style={{ whiteSpace: "nowrap" }}
            //       className="tittle-text"
            //       htmlFor="contact-type"
            //     >
            //       Contact Type
            //     </label>
            //     <select
            //       id="contact-type"
            //       className="form-select mt-2"
            //       aria-label="Default select example"
            //       name="contactType"
            //       value={formData?.contactType}
            //       onChange={(event) => {
            //         handleInputChange(event);
            //         handleContactType(event);
            //       }}
            //     >
            //       <option value="default">Select</option>
            //       <option type="number" className="inputText" value="Mobile">
            //         Mobile
            //       </option>
            //       <option value="Email">Email</option>
            //     </select>
            //   </div>
            //   <div className="col-md-8 d-flex   align-items-center ">
            //     <div className="col-md-5">
            //       <label className="tittle-text" htmlFor="mobileOrEmail">
            //         {contactType === "Email" ? "Email" : "Mobile Number"}
            //       </label>
            //       <input
            //         id="mobileOrEmail"
            //         type={contactType === "Email" ? "contactemail" : "text"}
            //         name={
            //           contactType === "Email"
            //             ? "contactemail"
            //             : "contactmobileNumber"
            //         }
            //         value={
            //           contactType === "Email"
            //             ? formData?.contactemail || ""
            //             : formData?.contactmobileNumber || ""
            //         }
            //         onChange={handleInputChange}
            //         placeholder={
            //           contactType === "Email"
            //             ? "Enter Your Email"
            //             : "Enter Your Mobile Number"
            //         }
            //         className="form-control mt-2"
            //       />
            //     </div>

            //     <div className="col-md-2  text-center row mt-3">
            //       <div
            //         style={{ cursor: "pointer" }}
            //         className="cursor-pointer ms-1 mt-3 "
            //         onClick={() => {
            //           handleContact();
            //         }}
            //       >
            //         <svg
            //           width="28"
            //           height="28"
            //           viewBox="0 0 28 28"
            //           fill="none"
            //           xmlns="http://www.w3.org/2000/svg"
            //         >
            //           <path
            //             d="M18.6875 10.6813L15.3219 14L18.6875 17.3188C18.7812 17.4064 18.8559 17.5124 18.9069 17.6302C18.958 17.7479 18.9843 17.8748 18.9843 18.0031C18.9843 18.1314 18.958 18.2584 18.9069 18.3761C18.8559 18.4938 18.7812 18.5998 18.6875 18.6875C18.5999 18.7744 18.496 18.8431 18.3818 18.8898C18.2676 18.9364 18.1453 18.9601 18.0219 18.9594C17.776 18.9583 17.5403 18.8607 17.3657 18.6875L14 15.3219L10.6813 18.6875C10.5067 18.8607 10.271 18.9583 10.025 18.9594C9.90165 18.9601 9.77934 18.9364 9.66512 18.8898C9.55089 18.8431 9.44701 18.7744 9.3594 18.6875C9.18479 18.5119 9.08679 18.2742 9.08679 18.0266C9.08679 17.7789 9.18479 17.5413 9.3594 17.3656L12.6782 14L9.3594 10.6813C9.20582 10.5019 9.12556 10.2712 9.13468 10.0353C9.14379 9.79932 9.2416 9.5755 9.40856 9.40854C9.57553 9.24158 9.79935 9.14376 10.0353 9.13465C10.2712 9.12554 10.5019 9.20579 10.6813 9.35938L14 12.6781L17.3188 9.35938C17.4056 9.26951 17.5092 9.19761 17.6238 9.14779C17.7384 9.09798 17.8617 9.07122 17.9866 9.06904C18.1115 9.06686 18.2356 9.08931 18.3519 9.13511C18.4681 9.1809 18.5742 9.24915 18.6641 9.33594C18.754 9.42274 18.8259 9.52639 18.8757 9.64097C18.9255 9.75555 18.9523 9.87882 18.9544 10.0037C18.9566 10.1287 18.9342 10.2528 18.8884 10.369C18.8426 10.4853 18.7743 10.5914 18.6875 10.6813ZM23.2813 23.2813C21.4457 25.1167 19.107 26.3666 16.561 26.8729C14.0151 27.3792 11.3761 27.1192 8.97795 26.1258C6.57975 25.1324 4.52998 23.4501 3.08784 21.2917C1.64571 19.1334 0.875977 16.5958 0.875977 14C0.875977 11.4042 1.64571 8.86665 3.08784 6.70829C4.52998 4.54992 6.57975 2.86765 8.97795 1.87422C11.3761 0.880776 14.0151 0.620779 16.561 1.1271C19.107 1.63342 21.4457 2.88333 23.2813 4.71876C24.5002 5.93754 25.4671 7.38449 26.1268 8.97698C26.7864 10.5695 27.126 12.2763 27.126 14C27.126 15.7237 26.7864 17.4305 26.1268 19.023C25.4671 20.6155 24.5002 22.0625 23.2813 23.2813ZM21.9594 6.04063C20.3845 4.4712 18.3799 3.40362 16.1987 2.9727C14.0175 2.54178 11.7575 2.76684 9.70407 3.61948C7.65067 4.47211 5.89597 5.91407 4.66153 7.76328C3.42709 9.61248 2.76828 11.786 2.76828 14.0094C2.76828 16.2328 3.42709 18.4063 4.66153 20.2555C5.89597 22.1047 7.65067 23.5466 9.70407 24.3993C11.7575 25.2519 14.0175 25.477 16.1987 25.0461C18.3799 24.6151 20.3845 23.5476 21.9594 21.9781C23.0082 20.933 23.8404 19.691 24.4082 18.3236C24.976 16.9561 25.2683 15.49 25.2683 14.0094C25.2683 12.5287 24.976 11.0626 24.4082 9.69517C23.8404 8.32771 23.0082 7.08579 21.9594 6.04063Z"
            //             fill="#034DA2"
            //           />
            //         </svg>
            //       </div>
            //     </div>
            //   </div>
            // </div>
            <div className="row mt-2 align-items-center">
              <div className="col-md-2">
                <label
                  style={{ whiteSpace: "nowrap" }}
                  className="tittle-text"
                  htmlFor="contact-type"
                >
                  Contact Type
                </label>
                <select
                  id="contact-type"
                  className="form-select mt-2"
                  aria-label="Default select example"
                  name="contactType"
                  value={formData?.contactType}
                  onChange={(event) => {
                    handleInputChange(event);
                    handleContactType(event); // Ensure this updates contactType state properly
                  }}
                >
                  <option value="default">Select</option>
                  <option value="Mobile">Mobile</option>
                  <option value="Email">Email</option>
                </select>
              </div>
              <div className="col-md-8 d-flex align-items-center">
                <div className="col-md-5">
                  <label className="tittle-text" htmlFor="mobileOrEmail">
                    {formData?.contactType === "Email"
                      ? "Email"
                      : "Mobile Number"}
                  </label>
                  <input
                    id="mobileOrEmail"
                    type={formData?.contactType === "Email" ? "email" : "text"}
                    name={
                      formData?.contactType === "Email"
                        ? "contactemail"
                        : "contactmobileNumber"
                    }
                    value={
                      formData?.contactType === "Email"
                        ? formData?.contactemail || ""
                        : formData?.contactmobileNumber || ""
                    }
                    onChange={handleInputChange}
                    placeholder={
                      formData?.contactType === "Email"
                        ? "Enter Your Email"
                        : "Enter Your Mobile Number"
                    }
                    className="form-control mt-2"
                  />
                </div>
                <div className="col-md-2 text-center row mt-3">
                  <div
                    style={{ cursor: "pointer" }}
                    className="cursor-pointer ms-1 mt-3"
                    onClick={() => {
                      handleContact();
                    }}
                  >
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.6875 10.6813L15.3219 14L18.6875 17.3188C18.7812 17.4064 18.8559 17.5124 18.9069 17.6302C18.958 17.7479 18.9843 17.8748 18.9843 18.0031C18.9843 18.1314 18.958 18.2584 18.9069 18.3761C18.8559 18.4938 18.7812 18.5998 18.6875 18.6875C18.5999 18.7744 18.496 18.8431 18.3818 18.8898C18.2676 18.9364 18.1453 18.9601 18.0219 18.9594C17.776 18.9583 17.5403 18.8607 17.3657 18.6875L14 15.3219L10.6813 18.6875C10.5067 18.8607 10.271 18.9583 10.025 18.9594C9.90165 18.9601 9.77934 18.9364 9.66512 18.8898C9.55089 18.8431 9.44701 18.7744 9.3594 18.6875C9.18479 18.5119 9.08679 18.2742 9.08679 18.0266C9.08679 17.7789 9.18479 17.5413 9.3594 17.3656L12.6782 14L9.3594 10.6813C9.20582 10.5019 9.12556 10.2712 9.13468 10.0353C9.14379 9.79932 9.2416 9.5755 9.40856 9.40854C9.57553 9.24158 9.79935 9.14376 10.0353 9.13465C10.2712 9.12554 10.5019 9.20579 10.6813 9.35938L14 12.6781L17.3188 9.35938C17.4056 9.26951 17.5092 9.19761 17.6238 9.14779C17.7384 9.09798 17.8617 9.07122 17.9866 9.06904C18.1115 9.06686 18.2356 9.08931 18.3519 9.13511C18.4681 9.1809 18.5742 9.24915 18.6641 9.33594C18.754 9.42274 18.8259 9.52639 18.8757 9.64097C18.9255 9.75555 18.9523 9.87882 18.9544 10.0037C18.9566 10.1287 18.9342 10.2528 18.8884 10.369C18.8426 10.4853 18.7743 10.5914 18.6875 10.6813ZM23.2813 23.2813C21.4457 25.1167 19.107 26.3666 16.561 26.8729C14.0151 27.3792 11.3761 27.1192 8.97795 26.1258C6.57975 25.1324 4.52998 23.4501 3.08784 21.2917C1.64571 19.1334 0.875977 16.5958 0.875977 14C0.875977 11.4042 1.64571 8.86665 3.08784 6.70829C4.52998 4.54992 6.57975 2.86765 8.97795 1.87422C11.3761 0.880776 14.0151 0.620779 16.561 1.1271C19.107 1.63342 21.4457 2.88333 23.2813 4.71876C24.5002 5.93754 25.4671 7.38449 26.1268 8.97698C26.7864 10.5695 27.126 12.2763 27.126 14C27.126 15.7237 26.7864 17.4305 26.1268 19.023C25.4671 20.6155 24.5002 22.0625 23.2813 23.2813ZM21.9594 6.04063C20.3845 4.4712 18.3799 3.40362 16.1987 2.9727C14.0175 2.54178 11.7575 2.76684 9.70407 3.61948C7.65067 4.47211 5.89597 5.91407 4.66153 7.76328C3.42709 9.61248 2.76828 11.786 2.76828 14.0094C2.76828 16.2328 3.42709 18.4063 4.66153 20.2555C5.89597 22.1047 7.65067 23.5466 9.70407 24.3993C11.7575 25.2519 14.0175 25.477 16.1987 25.0461C18.3799 24.6151 20.3845 23.5476 21.9594 21.9781C23.0082 20.933 23.8404 19.691 24.4082 18.3236C24.976 16.9561 25.2683 15.49 25.2683 14.0094C25.2683 12.5287 24.976 11.0626 24.4082 9.69517C23.8404 8.32771 23.0082 7.08579 21.9594 6.04063Z"
                        fill="#034DA2"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div>
            <button
              type="button"
              className="moreContact mt-3"
              onClick={() => {
                handleContact();
              }}
            >
              Add More Contact
            </button>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}

        {formData?.otp && formData?.isVerified && count < 5 && (
          <button className="rounded-5 btnBlue" type="submit">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps3;
